var contact1 = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

contact1.prototype.init = function(){

  var self = this;

};

module.exports = contact1;
